var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTwentytwo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1080 1080",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #1f2f60;\n      }\n\n      .cls-2 {\n        fill: #ccc;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M901.51,409.01v497.04H140.41v-497.04L520.96,117.78l380.55,291.24Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M901.51,409.01v497.04h-380.55V117.78l380.55,291.24Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M258.05,298.41c.27-.2.52-.41.8-.61v-150.89c0-16.09-13.04-29.12-29.12-29.12h-60.19c-16.09,0-29.12,13.04-29.12,29.12v241.6c37.03-28.8,79.13-60.08,117.64-90.09Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M520.96,350.77c-48.35,0-87.37,39.02-87.37,87.37s39.02,87.37,87.37,87.37,87.37-39.03,87.37-87.37-39.02-87.37-87.37-87.37Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M520.96,525.51v-174.74c48.35,0,87.37,39.02,87.37,87.37s-39.02,87.37-87.37,87.37Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M728.21,906.06h-414.51l-51.94,105.62c-4.08,8.74-4.08,19.81,1.17,27.96,5.82,8.74,15.15,13.98,25.04,13.98h465.98c9.91,0,19.23-5.24,25.05-13.98,5.24-8.15,5.24-19.23,1.17-27.96l-51.95-105.62Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M728.21,906.06h-207.26v147.56h232.99c9.9,0,19.23-5.24,25.04-13.98,5.25-8.15,5.25-19.23,1.17-27.96l-51.94-105.62Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1018,906.06c0,16.31-12.81,29.12-29.12,29.12H53.04c-16.31,0-29.12-12.82-29.12-29.12s12.81-29.12,29.12-29.12h935.84c16.31,0,29.12,12.81,29.12,29.12Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1018,906.06c0,16.31-12.81,29.12-29.12,29.12h-467.92v-58.25h467.92c16.31,0,29.12,12.81,29.12,29.12Z"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M724.82,612.88v322.3h-407.73v-322.3c0-16.31,12.81-29.12,29.12-29.12h349.48c16.31,0,29.12,12.81,29.12,29.12Z"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M724.82,612.88v322.3h-203.87v-351.42h174.74c16.31,0,29.12,12.81,29.12,29.12Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M375.34,642h116.49v234.93h-116.49v-234.93Z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M550.08,642h116.49v234.93h-116.49v-234.93Z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1017.42,445.71c1.17,7.58-.58,15.15-5.24,21.55l-34.95,46.6c-9.32,12.81-27.37,15.73-40.19,5.82l-416.08-321.53L105.46,519.68c-5.24,4.07-11.65,5.82-17.47,5.82-8.74,0-17.47-4.08-23.3-11.65l-34.95-46.6c-4.66-6.41-6.41-13.98-5.24-21.55.58-8.15,5.24-14.56,11.65-19.22L503.48,65.36c5.24-3.5,11.65-5.82,17.47-5.82s12.23,2.33,17.47,5.82l467.33,361.13c6.41,4.08,11.07,11.07,11.65,19.22Z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1017.42,445.71c1.17,7.58-.58,15.15-5.24,21.55l-34.95,46.6c-9.32,12.81-27.37,15.73-40.19,5.82l-416.08-321.53V59.53c5.82,0,12.23,2.33,17.47,5.82l467.33,361.13c6.41,4.08,11.07,11.07,11.65,19.22Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwentytwo);
export default __webpack_public_path__ + "static/media/twentytwo.91ba464000dcc4a3e6b17e3430fee50f.svg";
export { ForwardRef as ReactComponent };